const notfound = () => {
  const footer = document.querySelector('.footer');
  footer.classList.add('hidden');
}

export default notfound;
